import { Grid } from "@mui/material";
import * as d3 from "d3";
import React, { useEffect, useMemo, useState } from "react";
import { MapInteractionCSS } from "react-map-interaction";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CompanyHeader from "../../../common/CompanyHeader";
import { StyledCard } from "../../../common/Utils/StyledComponents";
import { rtlAction } from "../../../store/Reducer";
import Translate from "../../../translation/utils/translateFunction";
import CompanyListing from "../../ContactRepository/component";
import Loader from "../../staff/Owner/LoadingComp";
import { DeployNodes } from "../Components/DeployNodes";
import { NodeCurves } from "../Components/NodeCurves";
import { SiblingCurves } from "../Components/SiblingCurves";
import { flatten, getOwnerAndGmCount } from "../Components/utils";

const CompanyStructureMobile = ({ fixNavbar }) => {
  const { search } = useLocation(); //add code if view task dependancy from webview
  const query = new URLSearchParams(search);
  const { isRtl } = useSelector((state) => state.formanagement);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [displayNodes, setDisplayNodes] = useState();
  const [lines, setLines] = useState();
  const [siblingLines, setSiblingLines] = useState();
  const [showModal, setShowModal] = useState(false);
  const [treeWidth, setTreeWidth] = useState(1000);
  const [selectedCompany, setSelectedCompany] = useState([
    {
      label: query.get("selectedCompanyLabel"),
      value: query.get("selectedCompanyValue"),
    },
  ]);
  const [value, setValue] = useState({
    scale: 0.5, // 50% zoom (zoomed out)
    translation: { x: 0, y: 0 }, // Optional: adjust to center your content
  });
  const requestBody = useMemo(() => {
    const companyIds = selectedCompany?.length
      ? selectedCompany?.map((item) => item?.value)
      : [];

    const reqObj = {
      companyId: companyIds[0],
    };

    return companyIds?.length ? reqObj : null;
  }, [selectedCompany]);

  useEffect(() => {
    if (requestBody) {
      setIsLoading(true);
      const isRtlTemp = query.get("isrtl");
      if (isRtlTemp === "true") {
        dispatch(rtlAction(true));
        localStorage.setItem("isRtl", "true");
      } else {
        dispatch(rtlAction(false));
        localStorage.setItem("isRtl", "false");
      }
      fetch(query.get("url") + query.get("endPoint"), {
        method: "POST",
        body: JSON.stringify(requestBody),
        headers: {
          token: query.get("token"),
          "Content-Type": "application/json",
          timezone: query.get("timezone"),
        },
      })
        .then((res) => res.json())
        .then((res) => {
          setIsLoading(false);
          const { hierarchyData, sibilingData } = res?.data;
          const localData = JSON.parse(JSON.stringify(hierarchyData));
          generateTree(localData, sibilingData);
        })
        .catch((err) => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestBody]);

  const generateTree = (root, siblings) => {
    const allNodes = flatten(root); // flatten
    const { ownerCount, gmCount } = getOwnerAndGmCount(allNodes);
    const maxRoleWidth = Math.max(ownerCount, gmCount);
    const tempWidth = maxRoleWidth * 250;
    const treeHeight = gmCount > 0 ? 600 : 300;
    tempWidth > 1000 && setTreeWidth(tempWidth);
    const tree = d3?.layout?.tree()?.size([maxRoleWidth * 250, treeHeight]);
    const nodes = tree?.nodes(root);
    const links = tree?.links(nodes);
    const curves = NodeCurves(links);
    setLines(curves);

    const siblingPath = SiblingCurves(siblings, allNodes);
    setSiblingLines(siblingPath);
    const rectNodes = DeployNodes(allNodes);
    setDisplayNodes(rectNodes);
    setIsLoading(false);
  };

  return (
    <Grid item xs={12}>
      <StyledCard
        variant="outlined"
        sx={{ height: "100vh", marginTop: "0px", direction: "ltr" }}
      >
        <div className="container-fluid">
          <div className="tab-content">
            <div className="card cardHeight">
              <div className="row">
                <div className="col-12">
                  <div className="card-header fixedHeight">
                    <CompanyHeader
                      setShowModal={setShowModal}
                      selectedCompany={
                        selectedCompany[0]?.label ||
                        Translate("common:selectCompany")
                      }
                      fromWebView
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card-body">
                    {isLoading ? (
                      <Loader
                        isListLoader
                        loading={isLoading}
                        message={isRtl ? "تحميل..." : "loading..."}
                      />
                    ) : (
                      displayNodes && (
                        <MapInteractionCSS value={value} onChange={setValue}>
                          <svg width={treeWidth} height="1000">
                            <g>
                              {siblingLines}
                              {lines}
                              <foreignObject width="100%" height="100%">
                                {displayNodes}
                              </foreignObject>
                            </g>
                          </svg>
                        </MapInteractionCSS>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyledCard>

      <CompanyListing
        handleModal={setShowModal}
        showModal={showModal}
        selectedCompanyList={selectedCompany}
        isSingleSelect
        onSelect={(value) => {
          setSelectedCompany(value);
        }}
        isFilter
      />
    </Grid>
  );
};

export default CompanyStructureMobile;
